exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".GrantRevokeEmrManagerRole---lnTr8lCK1bTLtR8cgnpN {\n  padding-left: 5px;\n}\n", ""]);

// exports
exports.locals = {
	"grantRevokeEmrManagerRoleButtons": "GrantRevokeEmrManagerRole---lnTr8lCK1bTLtR8cgnpN",
	"grantRevokeEmrManagerRoleButtons": "GrantRevokeEmrManagerRole---lnTr8lCK1bTLtR8cgnpN"
};